import Guid from "common/values/guid/guid";
import WorkMarketplaceInfoAPIResponse from "work/contracts/responses/work-marketplace-info-api-response";
import EntityVendorRepresentative from "work/entities/entity-vendor-representative/entity-vendor-representative";
import DetailedVendorTeam from "work/values/vendor-team/detailed-vendor-team";
import VendorTeam from "work/values/vendor-team/vendor-team";
import { MaskedTeam } from "../../../../entities/work-agreement/work-agreement";
import EntityMember from "work/values/entity-member/entity-member";

export default class DetailedWorkVendorTeamAPIResponse {
  isMasked?: boolean;
  description?: string;
  leader?: WorkMarketplaceInfoAPIResponse;
  members: WorkMarketplaceInfoAPIResponse[] = [];
  marketplaceId?: string;

  public deserialize(): VendorTeam | MaskedTeam {
    if (this.isMasked) {
      return new MaskedTeam();
    }
    const marketplaceId = this.marketplaceId ? new Guid(this.marketplaceId) : undefined;
    const members = this.members.map((member) => {
      return Object.assign(new WorkMarketplaceInfoAPIResponse(), member).deserialize();
    });
    if(this.leader && !this.leader.userId) {
      throw new InvalidDetailedVendorWorkTeamAPIResponseError("Leader is missing userId");
    }
    if(this.leader && !this.leader.entityId) {
      throw new InvalidDetailedVendorWorkTeamAPIResponseError("Leader is missing entityId");
    }
    return new VendorTeam(
      this.leader ? EntityVendorRepresentative.fromJSON({ userId: this.leader.userId!, entityId: this.leader.entityId! }) : undefined,
      members.filter(member => member.userId && member.entityId).map(member => new EntityMember(member.userId, member.entityId!)),
      marketplaceId
    );
  }

  public deserializeDetailed(): DetailedVendorTeam | MaskedTeam {
    if (this.isMasked) {
      return new MaskedTeam();
    }
    return new DetailedVendorTeam(
      this.leader ? Object.assign(
        new WorkMarketplaceInfoAPIResponse(),
        this.leader
      ).deserialize() : undefined,
      this.members.map(member => Object.assign(
        new WorkMarketplaceInfoAPIResponse(),
        member).deserialize()
      ),
      this.marketplaceId ? new Guid(this.marketplaceId) : undefined,
      this.description,
    );
  }
}

export class InvalidDetailedVendorWorkTeamAPIResponseError extends Error { }
